<svg #svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="'0 0 ' + width + ' ' + height" preserveAspectRatio="none"></svg>
